/** Reading a knowledge document (ADR-0074). */
export default {
  en: {
    title: "Read a document",
    subtitle: "The text your agents search, passage by passage. You only see documents you could also find by searching.",
    back: "Back to Knowledge",
    collection: "Knowledge collection: {{name}}",
    level: "Data level",
    version: "Version {{version}}",
    current: "Current version",
    earlier: "Earlier version",
    earlierNote: "This is an earlier version. Agents search the current one.",
    openCurrent: "Open the current version",
    added: "Added {{at}}",
    validUntil: "Valid until {{at}}",
    passages: "Passages ({{n}})",
    passage: "Passage {{n}}",
    passageAria: "Go to passage {{n}}",
    shown: "Passage {{n}} is highlighted: this is the part an answer used.",
    text: "Text",
    download: "Download the text",
    originalNote: "The original file isn't kept: only its text is stored, which is what agents search.",
    history: "Version history",
    historyItem: "Version {{version}} · added {{at}}",
    historyOpen: "Open version {{version}}",
    notFound: "You can't read this document. It may have been removed, or it's limited to other people or a higher data level.",
    askWho: "Ask a knowledge curator of your organisation if you think you should see it.",
    read: "Read",
    readAria: "Read {{title}}",
    open: "Open this source",
    openAria: "Open {{title}} at this passage",
    openDoc: "Open {{title}}",
  },
  ar: {
    title: "قراءة مستند",
    subtitle: "النص الذي يبحث فيه وكلاؤك، مقطعًا مقطعًا. لا ترى إلا المستندات التي يمكنك العثور عليها بالبحث أيضًا.",
    back: "العودة إلى المعرفة",
    collection: "مجموعة المعرفة: {{name}}",
    level: "مستوى البيانات",
    version: "الإصدار {{version}}",
    current: "الإصدار الحالي",
    earlier: "إصدار سابق",
    earlierNote: "هذا إصدار سابق. يبحث الوكلاء في الإصدار الحالي.",
    openCurrent: "افتح الإصدار الحالي",
    added: "أُضيف في {{at}}",
    validUntil: "صالح حتى {{at}}",
    passages: "المقاطع ({{n}})",
    passage: "المقطع {{n}}",
    passageAria: "انتقل إلى المقطع {{n}}",
    shown: "المقطع {{n}} مظلَّل: هذا هو الجزء الذي استخدمته الإجابة.",
    text: "النص",
    download: "تنزيل النص",
    originalNote: "لا يُحتفظ بالملف الأصلي، بل بنصه فقط، وهو ما يبحث فيه الوكلاء.",
    history: "سجل الإصدارات",
    historyItem: "الإصدار {{version}} · أُضيف في {{at}}",
    historyOpen: "افتح الإصدار {{version}}",
    notFound: "لا يمكنك قراءة هذا المستند. ربما حُذف، أو أنه مقصور على أشخاص آخرين أو على مستوى بيانات أعلى.",
    askWho: "اسأل أحد أمناء المعرفة في جهتك إن كنت ترى أنه يحق لك الاطلاع عليه.",
    read: "قراءة",
    readAria: "قراءة {{title}}",
    open: "افتح هذا المصدر",
    openAria: "افتح {{title}} عند هذا المقطع",
    openDoc: "افتح {{title}}",
  },
} as const;
